// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as LangIndexRouteImport } from './routes/$lang.index'
import { Route as LangApiDocsRouteImport } from './routes/$lang.api-docs'
import { Route as LangBlogRouteImport } from './routes/$lang.blog'
import { Route as LangContactRouteImport } from './routes/$lang.contact'
import { Route as LangCookiesRouteImport } from './routes/$lang.cookies'
import { Route as LangFaqRouteImport } from './routes/$lang.faq'
import { Route as LangPricingRouteImport } from './routes/$lang.pricing'
import { Route as LangPrivacyRouteImport } from './routes/$lang.privacy'
import { Route as LangRefundRouteImport } from './routes/$lang.refund'
import { Route as LangTermsRouteImport } from './routes/$lang.terms'
import { Route as AppAccountsRouteImport } from './routes/_app.accounts'
import { Route as AppActivationsRouteImport } from './routes/_app.activations'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppApiKeysRouteImport } from './routes/_app.api-keys'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppEmailRouteImport } from './routes/_app.email'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppRechargeRouteImport } from './routes/_app.recharge'
import { Route as AppReferralsRouteImport } from './routes/_app.referrals'
import { Route as AppTicketsRouteImport } from './routes/_app.tickets'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as RefCodeRouteImport } from './routes/ref.$code'
import { Route as LangBlogIndexRouteImport } from './routes/$lang.blog.index'
import { Route as LangBlogSlugRouteImport } from './routes/$lang.blog.$slug'
import { Route as LangSmsIndexRouteImport } from './routes/$lang.sms.index'
import { Route as LangSmsServiceRouteImport } from './routes/$lang.sms.$service'
import { Route as AppAdminIndexRouteImport } from './routes/_app.admin.index'
import { Route as AppAdminTabRouteImport } from './routes/_app.admin.$tab'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/$lang/',path: '/$lang/',getParentRoute: () => rootRouteImport
          })
const LangApiDocsRoute = LangApiDocsRouteImport.update({
            id: '/$lang/api-docs',path: '/$lang/api-docs',getParentRoute: () => rootRouteImport
          })
const LangBlogRoute = LangBlogRouteImport.update({
            id: '/$lang/blog',path: '/$lang/blog',getParentRoute: () => rootRouteImport
          })
const LangContactRoute = LangContactRouteImport.update({
            id: '/$lang/contact',path: '/$lang/contact',getParentRoute: () => rootRouteImport
          })
const LangCookiesRoute = LangCookiesRouteImport.update({
            id: '/$lang/cookies',path: '/$lang/cookies',getParentRoute: () => rootRouteImport
          })
const LangFaqRoute = LangFaqRouteImport.update({
            id: '/$lang/faq',path: '/$lang/faq',getParentRoute: () => rootRouteImport
          })
const LangPricingRoute = LangPricingRouteImport.update({
            id: '/$lang/pricing',path: '/$lang/pricing',getParentRoute: () => rootRouteImport
          })
const LangPrivacyRoute = LangPrivacyRouteImport.update({
            id: '/$lang/privacy',path: '/$lang/privacy',getParentRoute: () => rootRouteImport
          })
const LangRefundRoute = LangRefundRouteImport.update({
            id: '/$lang/refund',path: '/$lang/refund',getParentRoute: () => rootRouteImport
          })
const LangTermsRoute = LangTermsRouteImport.update({
            id: '/$lang/terms',path: '/$lang/terms',getParentRoute: () => rootRouteImport
          })
const AppAccountsRoute = AppAccountsRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => AppRoute
          })
const AppActivationsRoute = AppActivationsRouteImport.update({
            id: '/activations',path: '/activations',getParentRoute: () => AppRoute
          })
const AppAdminRoute = AppAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRoute
          })
const AppApiKeysRoute = AppApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppEmailRoute = AppEmailRouteImport.update({
            id: '/email',path: '/email',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppRechargeRoute = AppRechargeRouteImport.update({
            id: '/recharge',path: '/recharge',getParentRoute: () => AppRoute
          })
const AppReferralsRoute = AppReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AppRoute
          })
const AppTicketsRoute = AppTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => AppRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const RefCodeRoute = RefCodeRouteImport.update({
            id: '/ref/$code',path: '/ref/$code',getParentRoute: () => rootRouteImport
          })
const LangBlogIndexRoute = LangBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangBlogRoute
          })
const LangBlogSlugRoute = LangBlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LangBlogRoute
          })
const LangSmsIndexRoute = LangSmsIndexRouteImport.update({
            id: '/$lang/sms/',path: '/$lang/sms/',getParentRoute: () => rootRouteImport
          })
const LangSmsServiceRoute = LangSmsServiceRouteImport.update({
            id: '/$lang/sms/$service',path: '/$lang/sms/$service',getParentRoute: () => rootRouteImport
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAdminRoute
          })
const AppAdminTabRoute = AppAdminTabRouteImport.update({
            id: '/$tab',path: '/$tab',getParentRoute: () => AppAdminRoute
          })





const AppAdminRouteChildren = {
  AppAdminTabRoute: AppAdminTabRoute,AppAdminIndexRoute: AppAdminIndexRoute
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(AppAdminRouteChildren)



const AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,AppActivationsRoute: AppActivationsRoute,AppAdminRoute: AppAdminRouteWithChildren,AppApiKeysRoute: AppApiKeysRoute,AppDashboardRoute: AppDashboardRoute,AppEmailRoute: AppEmailRoute,AppProfileRoute: AppProfileRoute,AppRechargeRoute: AppRechargeRoute,AppReferralsRoute: AppReferralsRoute,AppTicketsRoute: AppTicketsRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const LangBlogRouteChildren = {
  LangBlogSlugRoute: LangBlogSlugRoute,LangBlogIndexRoute: LangBlogIndexRoute
}

const LangBlogRouteWithChildren = LangBlogRoute._addFileChildren(LangBlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,LangApiDocsRoute: LangApiDocsRoute,LangBlogRoute: LangBlogRouteWithChildren,LangContactRoute: LangContactRoute,LangCookiesRoute: LangCookiesRoute,LangFaqRoute: LangFaqRoute,LangPricingRoute: LangPricingRoute,LangPrivacyRoute: LangPrivacyRoute,LangRefundRoute: LangRefundRoute,LangTermsRoute: LangTermsRoute,RefCodeRoute: RefCodeRoute,LangIndexRoute: LangIndexRoute,LangSmsServiceRoute: LangSmsServiceRoute,LangSmsIndexRoute: LangSmsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)